import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function GoogleCallback() {
  const [params] = useSearchParams();

  useEffect(() => {
    const data = {
      token: params.get("token"),
      type: params.get("type"),
      is_active: params.get("is_active"),
      email: params.get("email"),
      is_verified: params.get("is_verified"),
      data_profile: params.get("data_profile"),
    };

    if (window.opener) {
      window.opener.postMessage(
        {
          type: "GOOGLE_LOGIN_SUCCESS",
          payload: data,
        },
        window.location.origin
      );

      window.close();
    }
  }, []);

  return <div>Logging in...</div>;
}